export const getHomePath = (url?: string | null) => {
  if (!url) {
    return "/";
  }

  try {
    const urlObj = new URL(url);
    return urlObj.pathname;
  } catch (e) {
    return "/";
  }
};
